<template>
  <div class="section-y bg-stone-75">
    <div class="max-w-screen-xl m-auto px-4">
      <h2
        v-if="content?.title"
        class="section-title text-teal-900 feature-cards-title"
      >
        {{ content.title }}
      </h2>
      <p
        v-if="content?.subtitle"
        class="mt-2 md:mt-3 text-body-xl font-medium text-stone-700 max-w-xl"
      >
        {{ content.subtitle }}
      </p>

      <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6 md:mt-10">
        <div
          v-for="card in content?.cards"
          :key="card?.id"
          class="flex flex-col bg-white rounded-xl overflow-hidden p-2"
        >
          <div v-if="card?.image?.url" class="bg-stone-75 h-[180px]">
            <NuxtImg
              class="w-full h-full object-cover"
              :src="String(card?.image?.url)"
              :alt="card?.image?.alternativeText || card?.title || ''"
            />
          </div>

          <div class="flex flex-col p-4">
            <h3 class="text-body md:text-body-xl !font-medium text-teal-900">
              {{ card?.title }}
            </h3>

            <ul
              v-if="card?.bullets?.length"
              class="mt-4 flex flex-col gap-3 text-label md:text-body leading-snug md:leading-6 text-stone-700"
            >
              <li
                v-for="bullet in card.bullets"
                :key="bullet?.id"
                class="flex gap-2"
              >
                <span
                  class="mt-2 size-1 shrink-0 rounded-full bg-stone-400"
                  aria-hidden="true"
                />
                <span>
                  <strong
                    v-if="bullet?.lead"
                    class="font-semibold text-stone-800"
                    >{{ bullet.lead }}</strong
                  >
                  {{ bullet?.text }}
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const { content = {} } = defineProps<{ content: any }>()
</script>

<style lang="postcss" scoped>
.feature-cards-title {
  letter-spacing: 0.014em;
}
</style>
